import { ChangeEvent, useState } from "react";
import { Col, Row } from "reactstrap";
import { Btn, H6, P } from "../../../../AbstractElements";
import { PaymentInformation, ProceedNext } from "../../../../Constant";
import { BillingFormProp } from "../../../../Type/FormLayoutType";
import CashOnDelivery from "./CashOnDelivery";
import CreditCardOption from "./CreditCardOption";
import PayPalOption from "./PayPalOption";
import ShowError from "../../common/ShowError";

const PaymentForm = ({ callbackActive }: BillingFormProp) => {
  const [paymentMethodName, setPaymentMethodName] = useState("");
  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPaymentMethodName(value);
  };

  const handleNextButton = () => {
    if (paymentMethodName !== "") {
      callbackActive(4);
    } else {
      ShowError();
    }
  };

  return (
    <>
      <H6>{PaymentInformation}</H6>
      <P className="f-light">Fill up the following information to send you the order</P>
      <div className="payment-info-wrapper">
        <Row className="shipping-method g-3">
          <PayPalOption paymentMethodName={paymentMethodName} getUserData={getUserData}/>
          <CreditCardOption paymentMethodName={paymentMethodName} getUserData={getUserData}/>
          <CashOnDelivery paymentMethodName={paymentMethodName} getUserData={getUserData}/>
          <Col xs="12" className="text-end">
            <Btn color="primary" onClick={handleNextButton} className="btn-">
              {ProceedNext}
              <i className="fa fa-truck proceed-next pe-2" />
            </Btn>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PaymentForm;
